module.exports = __webpack_public_path__ + "static/media/cafeteria.fde02c06.svg";